import { AgGridReact } from "ag-grid-react";
import { useEffect, useRef, useState } from "react";
import { AG_GRID_DEFAULT_COL_DEF, AG_GRID_MODULES, AG_GRID_OPTIONS } from "../../../shared/constants";
import { ColumnsToolPanelModule, FiltersToolPanelModule, SetFilterModule } from "ag-grid-enterprise";

const ChangeLogTable = (props:{changeLogData:any}) => {
    const agGridRef = useRef(null);
    const colDefs:any = props.changeLogData.length > 0 ? Object.keys(props.changeLogData[0]).map((k:any)=>
         (
            {
                field: k,
                width: k==="description" ? 400 : 200,
                wrapText: true,
                autoHeight: true,
                valueFormatter: (params:any) => {
                    if (k === "datetime"){
                        const date = new Date(params.value);
                        return date.toUTCString(); // or use toLocaleDateString / toLocaleTimeString
                    }
                }
            }
        )
    ): [];


    return(
        <>
        <div className="ag-theme-balham mt-2" style={{ height: '80vh', width: '100%', overflowX: 'auto', overflowY: 'auto' }}>
            <AgGridReact
                ref={agGridRef} 
                rowData={props.changeLogData}
                columnDefs={colDefs}
                // gridOptions={{
                //     ...(AG_GRID_OPTIONS as any),
                //     suppressMenuHide: true,
                //     isExternalFilterPresent: (params: any) => true
                // }}
                defaultColDef={{
                    ...AG_GRID_DEFAULT_COL_DEF,
                }}
                modules={[
                    ...AG_GRID_MODULES,
                    ColumnsToolPanelModule,
                    FiltersToolPanelModule,
                    SetFilterModule
                ]}
                />
        </div>
        </>
    );
}
export default ChangeLogTable